import styled from "styled-components";
import { COLORS } from "Styles/Constants";

export const MobileHeaderContainer = styled.div`

    font-family: "Outfit", sans-serif;
 
    .mobile_header_wrapper {
        padding: 15px 0;
        .mygrid-row{
            align-items: center;
        }
    }
    .mobile_menu_nav {
        text-align: right;
        svg{
            font-weight:bold;
            font-size: 36px;
        }
        svg path{
            fill: #EE2D2F;
        }
    }
    .header_mobile_logo img {
        max-width: 130px;
    }
  

}
.MuiButton-label {
    justify-content: flex-end;
}
`;

export const DrawerListContainer = styled.div`

  /* Student Login button: same orange as "Join the Classroom Pilot" (C.cta in WebsiteTheme).
     The button arrow is drawn red, so recolour it. */
  .customs_btn {
    background: linear-gradient(90deg, #e2531a 0%, #cc430c 100%);
    box-shadow: 0 12px 24px -12px rgba(214, 72, 14, 0.75);

    &:hover {
      background: linear-gradient(90deg, #cf460f 0%, #b83a09 100%);
    }

    svg [fill="#EE2D2F" i] {
      fill: #e2531a;
    }
  }

  /* Social icons: same blue as the footer icons (navy on hover, like the footer) */
  .mobile_social_icons svg path[fill="#EE2D2F" i] {
    fill: #1f63e0;
    transition: fill 0.2s ease;
  }

  .mobile_social_icons a:hover svg path[fill="#EE2D2F" i] {
    fill: #142a6e;
  }


.MuiListItem-gutters {
    padding: 10px 25px;
}
.MuiListItem-button {
    font-family: 'outfit' , sans-serif;
    justify-content:center;
    &:hover{
        color: #1f63e0; /* same hover as the footer links */
    }
}.mobile_social_icons a {
    padding: 0 10px;
}
a.portal_login_link {
    color: #000;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    font-family: 'Outfit', sans-serif;
    -webkit-text-decoration: unset;
    text-decoration: unset;
    line-height: 1.1;
}
 .active {
    color: #1f63e0 !important; /* current page: same blue as the hover */
  }
`;